// Vuex user module main file
import actions from './actions';


// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  actions,
};

export default Module;
